import Module from "./Module.vue";

const moduleRoute = {
  path: "/join",
  name: "referral",
  component: Module,
  children: [
    {
      path: ":kode",
      name: "referral.register",
      component: Module,
      beforeEnter: (to, from, next) => {
        if (to.params.kode) {
          localStorage.kode_afiliasi = to.params.kode;
          next("register");
        } else {
          next("dahsboard");
        }
      },
    },
  ],
};

export default (router) => {
  router.addRoutes([moduleRoute]);
};
